import styled, { css } from 'styled-components';
import {
  Link,
  StatelessSideNav,
  styleMixinFocusOutline,
  Text,
  TextButton,
} from '@amzn/storm-ui';

export const StyledSideNav = styled(StatelessSideNav)`
  height: 100%;
`;

export const MobilePivotNavWrapper = styled.div`
  & nav {
    padding-inline-start: ${({ theme }) => theme.spacing.small.mobile};
  }
`;

export const GroupTitle = styled(Text)`
  font-weight: 700;
`;

export const GroupLinksWrapper = styled.div<{ hasLabel?: boolean }>`
  ${({ hasLabel }) =>
    hasLabel &&
    css`
      padding-inline-start: ${({ theme }) => theme.spacing.xxsmall.default};
    `};

  > span {
    width: 100%;
  }
`;

const sharedPivotElementStyles = css<{ active?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  cursor: pointer;
  padding-block: ${({ theme }) => theme.controls.paddingInline.large.default};
  padding-inline: ${({ theme }) => theme.controls.paddingInline.medium.default};
  border-radius: ${({ theme }) => theme.border.radius.small};
  font: ${({ theme }) => theme.font.text.base.default};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  color: ${({ theme }) => theme.text.color.default};
  background-color: ${({ theme }) =>
    theme.selectableContainer.backgroundColor.default};
  text-decoration: none;
  box-sizing: border-box;

  &&:hover {
    background-color: ${({ theme }) =>
      theme.selectableContainer.backgroundColor.hover};
    text-decoration: none;
    color: ${({ theme }) => theme.text.color.default};
  }

  :focus-visible {
    ${styleMixinFocusOutline};
  }

  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) =>
        theme.selectableContainer.backgroundColor.selected};
    `};
`;

export const PivotLink = styled(Link)`
  ${sharedPivotElementStyles};

  && {
    color: ${({ theme }) => theme.text.color.default};
    text-decoration: none;
  }
`;

export const PivotButton = styled(TextButton)`
  ${sharedPivotElementStyles};
`;

export const PivotElementLabel = styled(Text)`
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
`;
